module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "general-information row div-spacing-top"
  }, [_vm._m(0), _vm._v(" "), (_vm.Order.RequiredClinicEvent == true) ? _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "form-group order-div",
    class: {
      'spinner-disabled': (_vm.$route.params.EditOrReuse == '1' || _vm.$route.params.EditOrReuse == '2' || _vm.$route.params.EditOrReuse == '3')
    }
  }, [_c('label', [_vm._v("Clinic/Event")]), (_vm.Order.RequiredClinicEvent == true) ? _c('span', [_vm._v("*")]) : _vm._e(), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ClinicEvent),
      expression: "ClinicEvent"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.ValidationResult.OrderClinicEvent
    },
    attrs: {
      "name": "clinic",
      "disabled": (_vm.$route.params.EditOrReuse == '1' || _vm.$route.params.EditOrReuse == '2' || _vm.$route.params.EditOrReuse == '3')
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.ClinicEvent = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.ClinicEventChangedEvent]
    }
  }, [(_vm.ClinicEventList.length == 0) ? _c('option', {
    attrs: {
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v("No clinic/event to select..")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.ClinicEventList), function(item, index) {
    return _c('option', {
      attrs: {
        "selected": ""
      },
      domProps: {
        "value": item
      }
    }, [_vm._v(_vm._s(item.name || item.clinic_Name__c))])
  })], 2), _vm._v(" "), (_vm.ValidationResult.OrderClinicEvent) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderClinicEvent))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.Order.RequiredClinicEvent == true) ? _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "form-group order-div",
    class: {
      'spinner-disabled': _vm.disable_SchoolOrganization || (_vm.$route.params.EditOrReuse == '1' || _vm.$route.params.EditOrReuse == '2' || _vm.$route.params.EditOrReuse == '3')
    }
  }, [_c('label', [_vm._v("School/Organization")]), (_vm.Order.RequiredClinicEvent == true) ? _c('span', [_vm._v("*")]) : _vm._e(), _vm._v(" "), (!_vm.isUpdateCacheAndRefreshLoading && (!(_vm.$route.params.EditOrReuse == '1' || _vm.$route.params.EditOrReuse == '2' || _vm.$route.params.EditOrReuse == '3'))) ? _c('a', {
    staticClass: "pull-right",
    on: {
      "click": function($event) {
        return _vm.UpdateCacheAndRefresh()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })]) : _vm._e(), _vm._v(" "), (_vm.isUpdateCacheAndRefreshLoading) ? _c('img', {
    staticClass: "pull-right",
    attrs: {
      "src": _vm.pageLoader_img,
      "height": "30px",
      "width": "30px"
    }
  }) : _vm._e(), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.SchoolOrganization),
      expression: "SchoolOrganization"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.ValidationResult.OrderSchoolOrganization
    },
    attrs: {
      "disabled": _vm.disable_SchoolOrganization || (_vm.$route.params.EditOrReuse == '1' || _vm.$route.params.EditOrReuse == '2' || _vm.$route.params.EditOrReuse == '3'),
      "name": "Organization"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.SchoolOrganization = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.UpdateOrder()
      }]
    }
  }, _vm._l((_vm.SchoolOrganizationList), function(item, index) {
    return _c('option', {
      domProps: {
        "value": item
      }
    }, [_vm._v(_vm._s(item.school_Organization_Name__c))])
  }), 0), _vm._v(" "), (_vm.ValidationResult.OrderSchoolOrganization) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderSchoolOrganization))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.Account.accountType != 1 && _vm.accountType != 'Individual') ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "row no-gutters order-div"
  }, [_c('div', {
    staticClass: "col-lg-8 col-md-8 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Prescribing Doctor*")]), _vm._v(" "), _c('multiselect', {
    class: {
      error_field: _vm.ValidationResult.OrderEyeDoctorId
    },
    attrs: {
      "label": "eyeDoctorFullName",
      "options": _vm.Account.eyeDoctors,
      "deselectLabel": " ",
      "selectedLabel": " ",
      "placeholder": " ",
      "selectLabel": " "
    },
    on: {
      "close": function($event) {
        return _vm.SetPrescribingDoctorID(_vm.Order.PrescribingDoctorObject.salesforceId)
      }
    },
    model: {
      value: (_vm.Order.PrescribingDoctorObject),
      callback: function($$v) {
        _vm.$set(_vm.Order, "PrescribingDoctorObject", $$v)
      },
      expression: "Order.PrescribingDoctorObject"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("No elements found.")])]), _vm._v(" "), (_vm.ValidationResult.OrderEyeDoctorId) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderEyeDoctorId))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2 col-md-2 col-sm-12 col-xs-12 g-pt-30--md g-pt-0"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-main-blue--hover g-rounded-10 g-mt-3 g-mx-20",
    attrs: {
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        return _vm.ShowModal()
      }
    }
  }, [_vm._v("Add a Doctor\n                    "), _c('i', {
    staticClass: "fa fa-plus"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "form-group order-div"
  }, [_c('label', [_vm._v("Patient First Name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.PatFirstName),
      expression: "Order.PatFirstName"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.ValidationResult.OrderPatFirstName
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.Order.PatFirstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Order, "PatFirstName", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.ValidationResult.OrderPatFirstName) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderPatFirstName))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "form-group order-div"
  }, [_c('label', [_vm._v("Patient Last Name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.PatLastName),
      expression: "Order.PatLastName"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.ValidationResult.OrderPatLastName
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.Order.PatLastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Order, "PatLastName", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.ValidationResult.OrderPatLastName) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderPatLastName))]) : _vm._e()])]), _vm._v(" "), (_vm.Order.ShowExtraStudentFields == true) ? _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "form-group order-div"
  }, [_c('label', [_vm._v("Student ID")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.StudentID),
      expression: "Order.StudentID"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.Order.StudentID)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Order, "StudentID", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.Order.ShowExtraStudentFields == true) ? _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "form-group order-div"
  }, [_c('label', [_vm._v("Teacher/Room Number/Grade")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.TeacherRoomNum),
      expression: "Order.TeacherRoomNum"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.Order.TeacherRoomNum)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Order, "TeacherRoomNum", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-bottom"
  }, [_c('div', {
    staticClass: "row no-gutters order-div"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Referral Organization*")]), _vm._v(" "), _c('p', [_vm._v("If this patient was referred, please select the primary referral organization. If there was no referral organization involved, please select \"Not Applicable\".\n                    ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ReferralObject),
      expression: "ReferralObject"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.ValidationResult.OrderReferralOrg
    },
    staticStyle: {
      "height": "36.5px"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.ReferralObject = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.CheckVouchers()
      }]
    }
  }, _vm._l((_vm.VoucherList), function(vl, index) {
    return _c('option', {
      domProps: {
        "value": vl
      }
    }, [_vm._v(_vm._s(vl.name))])
  }), 0), _vm._v(" "), _c('small', [_vm._v("By selecting or indicating a Referral Organization for this order, you hereby consent to the disclosure to such Referral Organization of the prescribing doctor's information including, without limitation, to name and number of orders placed and warrant that you are authorized to provide such consent. ")]), _vm._v(" "), (_vm.ValidationResult.OrderReferralOrg) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderReferralOrg))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.isVoucherShown) ? _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12",
    class: {
      'col-md-12 col-lg-12': !(_vm.Order.ReferralOrg == 'Other'), 'col-md-6 col-lg-6': _vm.Order.ReferralOrg == 'Other'
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Referral Voucher Number/Code\n                            "), (_vm.isReferralCodeRequired) ? _c('span', [_vm._v("*")]) : _vm._e(), _vm._v(" "), (_vm.isVoucherCodeValid) ? _c('span', [_c('i', {
    staticClass: "fa fa-check-circle check_icon"
  })]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.ReferralCode),
      expression: "Order.ReferralCode"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.ValidationResult.OrderReferralCode, error_field: _vm.voucherValidation.OrderReferralCode
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.Order.ReferralCode)
    },
    on: {
      "blur": function($event) {
        return _vm.ValidateVoucherCode(_vm.Order.ReferralCode)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Order, "ReferralCode", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.ValidationResult.OrderReferralCode || _vm.voucherValidation.OrderReferralCode) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderReferralCode) + _vm._s(_vm.voucherValidation.OrderReferralCode))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.Order.ReferralOrg == 'Other') ? _c('div', {
    staticClass: " col-sm-12 col-xs-12",
    class: {
      'col-md-12 col-lg-12': !_vm.isVoucherShown, 'col-md-6 col-lg-6': _vm.isVoucherShown
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Other Referral Organization\n                          ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.OtherReferral),
      expression: "Order.OtherReferral"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.Order.OtherReferral)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Order, "OtherReferral", $event.target.value)
      }
    }
  })])]) : _vm._e()])])])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.Order.IsRemakeRedo) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-check  order-div"
  }, [_c('span', {
    attrs: {
      "hidden": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.IsRemakeRedo),
      expression: "Order.IsRemakeRedo"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.Order.IsRemakeRedo) ? _vm._i(_vm.Order.IsRemakeRedo, null) > -1 : (_vm.Order.IsRemakeRedo)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.Order.IsRemakeRedo,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.Order, "IsRemakeRedo", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.Order, "IsRemakeRedo", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.Order, "IsRemakeRedo", $$c)
        }
      }, function($event) {
        return _vm.RamakeRedoCheck(_vm.Order.IsRemakeRedo)
      }]
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "IsRemakeRedo"
  }, [_c('div', {
    staticClass: "form-group",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('label', [_vm._v("*Remake Reason:")]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticClass: "radio-inline radio_btn"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.RemakeRedoReason),
      expression: "Order.RemakeRedoReason"
    }],
    attrs: {
      "type": "radio",
      "checked": "checked",
      "name": "IsLabErrorRedo",
      "value": "OTH-LABREDO"
    },
    domProps: {
      "checked": _vm._q(_vm.Order.RemakeRedoReason, "OTH-LABREDO")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.Order, "RemakeRedoReason", "OTH-LABREDO")
      }
    }
  }), _vm._v(" Lab Error")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline radio_btn"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.RemakeRedoReason),
      expression: "Order.RemakeRedoReason"
    }],
    attrs: {
      "type": "radio",
      "name": "IsOrderEntryRedo",
      "value": "OTH-OPTERROR"
    },
    domProps: {
      "checked": _vm._q(_vm.Order.RemakeRedoReason, "OTH-OPTERROR")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.Order, "RemakeRedoReason", "OTH-OPTERROR")
      }
    }
  }), _vm._v(" Order Entry Error")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline radio_btn"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.RemakeRedoReason),
      expression: "Order.RemakeRedoReason"
    }],
    attrs: {
      "type": "radio",
      "name": "IsRxChangeRedo",
      "value": "OTH-OPENSOFT"
    },
    domProps: {
      "checked": _vm._q(_vm.Order.RemakeRedoReason, "OTH-OPENSOFT")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.Order, "RemakeRedoReason", "OTH-OPENSOFT")
      }
    }
  }), _vm._v(" Rx Change")])]), _vm._v(" "), (_vm.ValidationResult.OrderRemakeRedoReason) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderRemakeRedoReason))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("Remake Comments:")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.RemakeRedoComments),
      expression: "Order.RemakeRedoComments"
    }],
    staticClass: "form-control",
    attrs: {
      "required": _vm.Order.IsRemakeRedo,
      "maxlength": 225,
      "type": "text"
    },
    domProps: {
      "value": (_vm.Order.RemakeRedoComments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Order, "RemakeRedoComments", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.ValidationResult.OrderRemakeRedoComments) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.ValidationResult.OrderRemakeRedoComments))]) : _vm._e()])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-lg-8 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "form-group order-div",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('Label', [_vm._v("Select all that apply")]), _vm._v(" (Optional)\n              "), _c('div', {
    staticClass: "form-check"
  }, [_c('span', {}, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.IsExamOnly),
      expression: "Order.IsExamOnly"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "disabled": _vm.Order.IsExtra == true
    },
    domProps: {
      "checked": Array.isArray(_vm.Order.IsExamOnly) ? _vm._i(_vm.Order.IsExamOnly, null) > -1 : (_vm.Order.IsExamOnly)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.Order.IsExamOnly,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.Order, "IsExamOnly", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.Order, "IsExamOnly", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.Order, "IsExamOnly", $$c)
        }
      }, function($event) {
        return _vm.ClearFirstTimeGlasses(_vm.Order.IsExamOnly)
      }]
    }
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), (_vm.Order.ShowExtraStudentFields == true) ? _c('div', {
    staticClass: "form-check"
  }, [_c('span', {}, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.IsReferredForEval),
      expression: "Order.IsReferredForEval"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "disabled": _vm.Order.IsExtra == true
    },
    domProps: {
      "checked": Array.isArray(_vm.Order.IsReferredForEval) ? _vm._i(_vm.Order.IsReferredForEval, null) > -1 : (_vm.Order.IsReferredForEval)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.Order.IsReferredForEval,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.Order, "IsReferredForEval", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.Order, "IsReferredForEval", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.Order, "IsReferredForEval", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "g-font-size-18"
  }, [_vm._v("Referred for Further Evaluation")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', [(_vm.Order.IsReferredForEval) ? _c('div', {
    staticClass: "form-group order-div"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('span', {}, [_c('multi-select-checkbox', {
    staticClass: "form-check-input",
    attrs: {
      "val": "Amblyopia f/u",
      "disabled": _vm.Order.IsExtra == true,
      "checked": _vm.referralReasonChecked
    },
    model: {
      value: (_vm.Order.ReferralReasonsArray),
      callback: function($$v) {
        _vm.$set(_vm.Order, "ReferralReasonsArray", $$v)
      },
      expression: "Order.ReferralReasonsArray"
    }
  }), _vm._v(" "), _vm._m(7)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('span', {}, [_c('multi-select-checkbox', {
    staticClass: "form-check-input",
    attrs: {
      "val": "Strabismus f/u",
      "disabled": _vm.Order.IsExtra == true,
      "checked": _vm.referralReasonChecked
    },
    model: {
      value: (_vm.Order.ReferralReasonsArray),
      callback: function($$v) {
        _vm.$set(_vm.Order, "ReferralReasonsArray", $$v)
      },
      expression: "Order.ReferralReasonsArray"
    }
  }), _vm._v(" "), _vm._m(8)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('span', {}, [_c('multi-select-checkbox', {
    staticClass: "form-check-input",
    attrs: {
      "val": "Dilated eye health exam",
      "disabled": _vm.Order.IsExtra == true,
      "checked": _vm.referralReasonChecked
    },
    model: {
      value: (_vm.Order.ReferralReasonsArray),
      callback: function($$v) {
        _vm.$set(_vm.Order, "ReferralReasonsArray", $$v)
      },
      expression: "Order.ReferralReasonsArray"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "g-font-size-15"
  }, [_vm._v("Dilated eye health exam")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('span', {}, [_c('multi-select-checkbox', {
    staticClass: "form-check-input",
    attrs: {
      "val": "Cycloplegic refraction",
      "disabled": _vm.Order.IsExtra == true,
      "checked": _vm.referralReasonChecked
    },
    model: {
      value: (_vm.Order.ReferralReasonsArray),
      callback: function($$v) {
        _vm.$set(_vm.Order, "ReferralReasonsArray", $$v)
      },
      expression: "Order.ReferralReasonsArray"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "g-font-size-15"
  }, [_vm._v("Cycloplegic refraction")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('span', {}, [_c('multi-select-checkbox', {
    staticClass: "form-check-input",
    attrs: {
      "val": "Vision check after wearing new glasses",
      "disabled": _vm.Order.IsExtra == true,
      "checked": _vm.referralReasonChecked
    },
    model: {
      value: (_vm.Order.ReferralReasonsArray),
      callback: function($$v) {
        _vm.$set(_vm.Order, "ReferralReasonsArray", $$v)
      },
      expression: "Order.ReferralReasonsArray"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "g-font-size-15"
  }, [_vm._v("Vision check after wearing new glasses")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('span', {}, [_c('multi-select-checkbox', {
    staticClass: "form-check-input",
    attrs: {
      "val": "Vision Therapy",
      "disabled": _vm.Order.IsExtra == true,
      "checked": _vm.referralReasonChecked
    },
    model: {
      value: (_vm.Order.ReferralReasonsArray),
      callback: function($$v) {
        _vm.$set(_vm.Order, "ReferralReasonsArray", $$v)
      },
      expression: "Order.ReferralReasonsArray"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "g-font-size-15"
  }, [_vm._v("Vision Therapy")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('span', {}, [_c('multi-select-checkbox', {
    staticClass: "form-check-input",
    attrs: {
      "val": "Other",
      "disabled": _vm.Order.IsExtra == true,
      "checked": _vm.referralReasonChecked
    },
    model: {
      value: (_vm.Order.ReferralReasonsArray),
      callback: function($$v) {
        _vm.$set(_vm.Order, "ReferralReasonsArray", $$v)
      },
      expression: "Order.ReferralReasonsArray"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "g-font-size-15"
  }, [_vm._v("Other")])], 1)]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.ReferralNotes),
      expression: "Order.ReferralNotes"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.Order.ReferralNotes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Order, "ReferralNotes", $event.target.value)
      }
    }
  })]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('span', {}, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.IsInternationalMission),
      expression: "Order.IsInternationalMission"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.Order.IsInternationalMission) ? _vm._i(_vm.Order.IsInternationalMission, null) > -1 : (_vm.Order.IsInternationalMission)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.Order.IsInternationalMission,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.Order, "IsInternationalMission", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.Order, "IsInternationalMission", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.Order, "IsInternationalMission", $$c)
        }
      }
    }
  }), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('span', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.down",
      value: ({
        html: 'tooltipContentInternational',
        class: 'custom-tooltip'
      }),
      expression: "{ html: 'tooltipContentInternational', class: 'custom-tooltip' }",
      modifiers: {
        "down": true
      }
    }]
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o",
    staticStyle: {
      "cursor": "pointer"
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "tooltipContentInternational"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.internationalMissionTooltip)
    }
  })])]), _vm._v(" "), (_vm.Order.IsExtra) ? _c('div', {
    staticClass: "form-check"
  }, [_c('span', {}, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.IsExtra),
      expression: "Order.IsExtra"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "disabled": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.Order.IsExtra) ? _vm._i(_vm.Order.IsExtra, null) > -1 : (_vm.Order.IsExtra)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.Order.IsExtra,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.Order, "IsExtra", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.Order, "IsExtra", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.Order, "IsExtra", $$c)
        }
      }
    }
  }), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12)])]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "form-group order-div",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('label', [_vm._v("Order Reference/PO")]), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Order.ReferenceNoPo),
      expression: "Order.ReferenceNoPo"
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": 15,
      "type": "text"
    },
    domProps: {
      "value": (_vm.Order.ReferenceNoPo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Order, "ReferenceNoPo", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), (_vm.isModalShown) ? _c('div', [_c('div', {
    staticClass: "modal-mask",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "overlay-mask"
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "close_btn",
    on: {
      "click": function($event) {
        return _vm.CloseModal()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row g-mt-20 g-mx-20"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-5 col-md-6 col-sm-7 col-xs-10"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("NPI Number\n                                                    "), (!_vm.Doctor.UseLicenseNumber) ? _c('span', [_vm._v("*")]) : _vm._e(), _vm._v(" "), _c('span', {
    attrs: {
      "data-balloon": _vm.npiTooltip,
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Doctor.NpiNumber),
      expression: "Doctor.NpiNumber"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.DoctorValidation.EyeDoctorNpiNumber
    },
    attrs: {
      "type": "text",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.Doctor.NpiNumber)
    },
    on: {
      "keypress": function($event) {
        return _vm.NumberCheck(this.event)
      },
      "keyup": function($event) {
        return _vm.ValidateNpiNumberNewDoctor()
      },
      "change": function($event) {
        return _vm.changedNPINumber()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Doctor, "NpiNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.DoctorValidation.EyeDoctorNpiNumber) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.DoctorValidation.EyeDoctorNpiNumber))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5 col-md-6 col-sm-7 col-xs-10"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Relationship*\n                                                "), _c('span', {
    attrs: {
      "data-balloon": _vm.relationshipTooltip,
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Doctor.Role),
      expression: "Doctor.Role"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.DoctorValidation.EyeDoctorRole
    },
    staticStyle: {
      "height": "36.5px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.Doctor, "Role", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("Self")]), _vm._v(" "), _c('option', [_vm._v("Employee")]), _vm._v(" "), _c('option', [_vm._v("Contractor")]), _vm._v(" "), _c('option', [_vm._v("Unaffiliated")]), _vm._v(" "), _c('option', [_vm._v("Other")])]), _vm._v(" "), (_vm.DoctorValidation.EyeDoctorRole) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.DoctorValidation.EyeDoctorRole))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(!_vm.Doctor.UseLicenseNumber) ? _c('div', {
    staticClass: "clearfix"
  }) : _vm._e(), _vm._v(" "), (_vm.Doctor.UseLicenseNumber) ? _c('div', {
    staticClass: "col-lg-5 col-md-6 col-sm-7 col-xs-10"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("License Number *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Doctor.LicenseNumber),
      expression: "Doctor.LicenseNumber"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.DoctorValidation.EyeDoctorLicenseNumber
    },
    attrs: {
      "maxlength": "18",
      "type": "text"
    },
    domProps: {
      "value": (_vm.Doctor.LicenseNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Doctor, "LicenseNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.DoctorValidation.EyeDoctorLicenseNumber) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.DoctorValidation.EyeDoctorLicenseNumber))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.Doctor.UseLicenseNumber) ? _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("State*")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Doctor.State),
      expression: "Doctor.State"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.DoctorValidation.EyeDoctorState
    },
    staticStyle: {
      "height": "36.5px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.Doctor, "State", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.State), function(value, key) {
    return _c('option', {
      domProps: {
        "value": value
      }
    }, [_vm._v(_vm._s(value))])
  }), 0), _vm._v(" "), (_vm.DoctorValidation.EyeDoctorState) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.DoctorValidation.EyeDoctorState))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.useLicenseNumber),
      expression: "useLicenseNumber"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.useLicenseNumber) ? _vm._i(_vm.useLicenseNumber, null) > -1 : (_vm.useLicenseNumber)
    },
    on: {
      "click": function($event) {
        return _vm.iDontHaveNPINumber()
      },
      "change": function($event) {
        var $$a = _vm.useLicenseNumber,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.useLicenseNumber = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.useLicenseNumber = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.useLicenseNumber = $$c
        }
      }
    }
  }), _vm._v(" "), _c('p', [_vm._v("I don't have an NPI Number")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Doctor First Name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Doctor.FirstName),
      expression: "Doctor.FirstName"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.DoctorValidation.EyeDoctorFirstName
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.Doctor.FirstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Doctor, "FirstName", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.DoctorValidation.EyeDoctorFirstName) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.DoctorValidation.EyeDoctorFirstName))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Doctor Last Name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Doctor.LastName),
      expression: "Doctor.LastName"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.DoctorValidation.EyeDoctorLastName
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.Doctor.LastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Doctor, "LastName", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.DoctorValidation.EyeDoctorLastName) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.DoctorValidation.EyeDoctorLastName))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Suffix*")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Doctor.Suffix),
      expression: "Doctor.Suffix"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.DoctorValidation.EyeDoctorSuffix
    },
    staticStyle: {
      "height": "36.5px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.Doctor, "Suffix", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.Suffix), function(value, key) {
    return _c('option', {
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(key))])
  }), 0), _vm._v(" "), (_vm.DoctorValidation.EyeDoctorSuffix) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.DoctorValidation.EyeDoctorSuffix))]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Doctor's Email Address*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Doctor.EmailAddress),
      expression: "Doctor.EmailAddress"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.DoctorValidation.EyeDoctorEmailAddress
    },
    attrs: {
      "type": "text",
      "oninput": "this.value = this.value.toLowerCase()"
    },
    domProps: {
      "value": (_vm.Doctor.EmailAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Doctor, "EmailAddress", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.DoctorValidation.EyeDoctorEmailAddress) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.DoctorValidation.EyeDoctorEmailAddress))]) : _vm._e()])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center g-my-10"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-main-blue--hover g-rounded-10 g-mx-10 g-my-10",
    attrs: {
      "data-balloon": "This doctor’s information will only be used for this order and will not be saved to your account for future use",
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    },
    on: {
      "click": function($event) {
        return _vm.AddDoctorForThisJobOnly()
      }
    }
  }, [_vm._v("Use for this job only")]), _vm._v(" "), _c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-main-blue--hover g-rounded-10 g-mx-10 g-my-10",
    attrs: {
      "data-balloon": "This doctor’s information will be used for this order and will be saved to your account.  It will be available in the “Prescribing Doctor” drop down field",
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    },
    on: {
      "click": function($event) {
        return _vm.AddDoctorAndUseNow()
      }
    }
  }, [_vm._v("Save and use now")])])])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('loading-component') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "order-title"
  }, [_vm._v("\n      General Information\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "g-font-size-18"
  }, [_vm._v("Remake/Redo "), _c('small', [_vm._v("(Due to error – i.e. order entry/lab error)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    attrs: {
      "data-balloon": "Select this box when submitting a remake or redo order.",
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "g-font-size-18"
  }, [_vm._v("Exam Only "), _c('small', [_vm._v("(Patient not issued a prescription)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    attrs: {
      "data-balloon": "A record will be stored in Track Orders, but no order will be sent to the lab.  This exam can later be changed into an order from the Track Order page.",
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    attrs: {
      "data-balloon": "A record will be stored in Track Orders, but no order will be sent to the lab.  This exam can later be changed into an order from the Track Order page.",
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('b', [_vm._v("Referral Reason(s)*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "g-font-size-15"
  }, [_vm._v("Amblyopia f/u "), _c('small', [_vm._v("(aka Lazy Eye)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "g-font-size-15"
  }, [_vm._v("Strabismus f/u "), _c('small', [_vm._v("(aka Crossed Eyes)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('b', [_vm._v("Referral Notes:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "font-order"
  }, [_vm._v("International Mission "), _c('small', [_vm._v("(One-Time Support shipped to domestic participant)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "g-font-size-18"
  }, [_vm._v("Extra Pair "), _c('small', [_vm._v("(Back up pair for patient with high Rx) ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    attrs: {
      "data-balloon": "A record will be stored in Track Orders, but no order will be sent to the lab.  This exam can later be changed into an order from the Track Order page.",
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "left",
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "data-balloon": "The text in this optional field will be printed on the lab ticket with the completed job and may be used for your internal tracking/sorting purposes. (i.e. School/Event Name, Patient ID, etc)",
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0733c9a4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0733c9a4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/Order/OrderComponent/GeneralInformation.vue
// module id = 474
// module chunks = 4